import { MutableRefObject, useState } from "react";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import * as UserStore from "../../store/user/User";
import SpinnerButton from "../../components/SpinnerButton";

export interface LoginProps {
    onSubmitCallbackRef: MutableRefObject<() => void>;
}

function Login(props: LoginProps) {
    const dispatch = useDispatch();
    const user = useSelector((state: ApplicationState) => state.user);
    const isUpdatingAuth = user?.loginIssueParams?.isUpdatingAuth ?? false;

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [isForgotPasswordClicked, setIsForgotPasswordClicked] = useState(false);

    function handleRevealPasswordClicked(event: React.ChangeEvent<HTMLInputElement>) {
        setIsPasswordVisible(event.target.checked);
    }

    function handleUsernameChange(event: React.ChangeEvent<HTMLInputElement>) {
        event.preventDefault();
        setUsername(event.target.value);
    }

    function handlePasswordChange(event: React.ChangeEvent<HTMLInputElement>) {
        event.preventDefault();
        setPassword(event.target.value);
    }

    function handleForgotPasswordClicked(event: React.MouseEvent<HTMLAnchorElement>) {
        event.preventDefault();
        setIsForgotPasswordClicked(true);
    }

    function handleForgotPasswordBackClicked(event: React.MouseEvent<HTMLAnchorElement>) {
        event.preventDefault();
        setIsForgotPasswordClicked(false);
    }

    if (props.onSubmitCallbackRef?.current) {
        props.onSubmitCallbackRef.current = () => dispatch(UserStore.actionCreators.logInUser(username, password));
    }

    return (
        <>
            <div className="login-title">{isForgotPasswordClicked ? "Reset Password" : "Login"}</div>

            <div className="login-fields" style={{ marginTop: "1rem" }}>
                {isForgotPasswordClicked && (
                    <div style={{ marginBottom: "1rem" }}>
                        Request a verification code from your administrator, then enter your username below and click
                        Reset.
                    </div>
                )}
                <Form.Control
                    autoFocus
                    type="text"
                    value={username}
                    placeholder="Username"
                    onChange={handleUsernameChange}
                    required
                />

                {!isForgotPasswordClicked && (
                    <>
                        <Form.Control
                            type={isPasswordVisible ? "text" : "password"}
                            value={password}
                            placeholder="Password"
                            onChange={handlePasswordChange}
                            required
                        />

                        <Form.Check type="checkbox" label="Show Password" onChange={handleRevealPasswordClicked} />
                    </>
                )}

                {user?.loginIssue != undefined && <span className="text-danger">Incorrect username or password.</span>}
            </div>
            <div className="login-actions">
                {!isForgotPasswordClicked && <a onClick={handleForgotPasswordClicked}>Forgot password?</a>}
                {isForgotPasswordClicked && <a onClick={handleForgotPasswordBackClicked}>Back</a>}

                <div style={{ justifySelf: "end" }}>
                    <SpinnerButton
                        buttonProps={{ type: "submit" }}
                        label={isForgotPasswordClicked ? "Reset" : "Login"}
                        isLoading={isUpdatingAuth}
                    />
                </div>
            </div>
        </>
    );
}

export default Login;
